import { DashboardKeys } from '../Keys'

import { useGetOne } from '../request'

import type { DashboardResponse } from '@models/Dashboard'

const PATHS = {
  stats: '/api/teams/stats',
}

// QuickMenu (nav), RequestsList, Dashboard, RequestForm, and Pipelines all
// call useGetStats(). Default React Query staleTime is 0, so when any two
// mount close together they both fire a `/api/teams/stats` request — observed
// as a duplicate ~1.5s call on the approval-requests page load. The stats
// payload (workflow count, monthly request count, completion average) only
// changes when an AR is created/completed, so a 60s staleness window is
// imperceptible to the user and collapses the duplicates to one network call.
const STATS_STALE_TIME = 60_000

export const useGetStats = () => {
  return useGetOne<DashboardResponse>([DashboardKeys.Dashboard], `${PATHS.stats}`, {
    query: { staleTime: STATS_STALE_TIME },
  })
}
